import React from 'react';
import PropTypes from 'prop-types';

import { getColor, AVAILABLE_COLORS } from '../utils/colors';

const SIZES = {
  extra_small: 11,
  small: 14,
  normal: 26
};

const Close = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SIZES[props.size]}
    height={SIZES[props.size]}
    viewBox="0 0 44 44"
  >
    <g
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(props.theme) || props.theme}
    >
      <path d="M38.824,0 L44,5.178 L5.176,44 L0,38.825 L38.824,0z" />
      <path d="M5.176,0 L44,38.825 L38.824,44 L0,5.178 L5.176,0z" />
    </g>
  </svg>
);

Close.propTypes = {
  size: PropTypes.oneOf(['normal', 'small', 'extra_small']),
  theme: PropTypes.oneOf(AVAILABLE_COLORS)
};

Close.defaultProps = {
  size: 'normal',
  theme: ''
};

export default Close;
